import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  filters: {
    id: 'components.filters.filters',
    defaultMessage: 'Filters'
  },
  reset: {
    id: 'components.filters.reset',
    defaultMessage: 'Reset'
  },
  mostPopular: {
    id: 'components.filters.mostPopular',
    defaultMessage: 'Most Popular'
  },
  mainCategories: {
    id: 'components.filters.mainCategories',
    defaultMessage: 'Categories'
  },
  topics: {
    id: 'components.filters.topics',
    defaultMessage: 'Topics'
  },
  alphabetically: {
    id: 'components.filters.alphabetically',
    defaultMessage: 'Alphabetically'
  },
  noResults: {
    id: 'components.filters.noResults',
    defaultMessage: 'No results match "{query}"'
  },
  categories: {
    id: 'components.filters.categories',
    defaultMessage: 'Categories'
  },
  categories_1: {
    id: 'components.filters.categories_1',
    defaultMessage: 'Categories'
  },
  categories_2: {
    id: 'components.filters.categories_2',
    defaultMessage: 'Categories'
  },
  categories_3: {
    id: 'components.filters.categories_3',
    defaultMessage: 'Categories'
  },
  categories_4: {
    id: 'components.filters.categories_4',
    defaultMessage: 'Categories'
  },
  country: {
    id: 'components.filters.country',
    defaultMessage: 'Country/Region'
  },
  activityCountry: {
    id: 'components.filters.activityCountry',
    defaultMessage: 'Activity Country/Region'
  },
  projectsCategory: {
    id: 'components.filters.projectsCategory',
    defaultMessage: 'Projects Category'
  },
  offices: {
    id: 'components.filters.offices',
    defaultMessage: 'Architects'
  },
  year: {
    id: 'components.filters.year',
    defaultMessage: 'Year'
  },
  materials: {
    id: 'components.filters.materials',
    defaultMessage: 'Materials'
  },
  area: {
    id: 'components.filters.area',
    defaultMessage: 'Area'
  },
  projectsArea: {
    id: 'components.filters.projects_area',
    defaultMessage: 'Projects Area'
  },
  color: {
    id: 'components.filters.color',
    defaultMessage: 'Color'
  },
  apply: {
    id: 'components.filters.apply',
    defaultMessage: 'Apply'
  },
  companies: {
    id: 'components.filters.companies',
    defaultMessage: 'Manufacturers'
  },
  allResults: {
    id: 'components.filters.allResults',
    defaultMessage: 'All Results'
  },
  allCompanies: {
    id: 'components.filters.allCompanies',
    defaultMessage: 'All Manufacturers'
  },
  allOffices: {
    id: 'components.filters.allOffices',
    defaultMessage: 'All Architects'
  },
  allCategories: {
    id: 'components.filters.allCategories',
    defaultMessage: 'All Categories'
  },
  properties: {
    id: 'components.filters.properties',
    defaultMessage: 'properties'
  },
  product_type: {
    id: 'components.filters.product_type',
    defaultMessage: 'Article Type'
  },
  use: {
    id: 'components.filters.use',
    defaultMessage: 'Use'
  },
  bim: {
    id: 'components.filters.bim',
    defaultMessage: 'Show Only BIM files'
  },
  application: {
    id: 'components.filters.bim',
    defaultMessage: 'Show Only Applications'
  },
  image_type: {
    id: 'components.filters.image_type',
    defaultMessage: 'Image Type'
  },
  space: {
    id: 'components.filters.space',
    defaultMessage: 'Space'
  },
  building_element: {
    id: 'components.filters.construction',
    defaultMessage: 'Building Element'
  },
  fixtures_and_furniture: {
    id: 'components.filters.interior',
    defaultMessage: 'Fixtures & Furniture'
  },
  environment: {
    id: 'components.filters.environment',
    defaultMessage: 'Environment'
  },
  projectCategory: {
    id: 'components.filters.project_category',
    defaultMessage: 'Project Category'
  },
  expertise: {
    id: 'components.filters.expertise',
    defaultMessage: 'Expertise'
  },
  expertise_1: {
    id: 'components.filters.expertise_1',
    defaultMessage: 'Expertise 1'
  },
  expertise_2: {
    id: 'components.filters.expertise_2',
    defaultMessage: 'Expertise 2'
  },
  states: {
    id: 'components.filters.states',
    defaultMessage: 'States'
  },
  author: {
    id: 'components.filters.author',
    defaultMessage: 'Author'
  },
  tag: {
    id: 'components.filters.tag',
    defaultMessage: 'Topic'
  },
  tags: {
    id: 'components.filters.tags',
    defaultMessage: 'Tags'
  }
})
export const colorMessages = defineMessages({
  blue: {
    id: 'components.filters.colors.blue',
    defaultMessage: 'Blue'
  },
  green: {
    id: 'components.filters.colors.green',
    defaultMessage: 'Green'
  },
  red: {
    id: 'components.filters.colors.red',
    defaultMessage: 'Red'
  },
  yellow: {
    id: 'components.filters.colors.yellow',
    defaultMessage: 'Yellow'
  },
  pink: {
    id: 'components.filters.colors.pink',
    defaultMessage: 'Pink'
  },
  orange: {
    id: 'components.filters.colors.orange',
    defaultMessage: 'Orange'
  },
  brown: {
    id: 'components.filters.colors.brown',
    defaultMessage: 'Brown'
  },
  purple: {
    id: 'components.filters.colors.purple',
    defaultMessage: 'Purple'
  },
  teal: {
    id: 'components.filters.colors.teal',
    defaultMessage: 'Teal'
  },
  gray: {
    id: 'components.filters.colors.gray',
    defaultMessage: 'Gray'
  },
  white: {
    id: 'components.filters.colors.white',
    defaultMessage: 'White'
  },
  black: {
    id: 'components.filters.colors.black',
    defaultMessage: 'Black'
  }
})
